import { createContext } from 'react';

const RootContext = createContext<any>({})

export default RootContext